/* global Razorpay */
import { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useStore } from '../../store/store';
import CryptoJS from 'crypto-js';
import spinner from '../../assets/spinner.svg';
import clock from '../../assets/clock.svg';
const IndiaPayment = () => {
  const { paymentData, setPaymentData } = useStore();
  const [paymentPending, setBeforePayment] = useState(true);
  const [paymentID, setPaymentID] = useState(null); //pay_R4jBOFuGba928M
  const [appointmentID, setAppointmentID] = useState(null);
  const [startTimer, setStartTimer] = useState(false);
  const [minutes, setMinutes] = useState(9);
  const [seconds, setSeconds] = useState(0);
  const countDownRef = useRef(null);
  const pollingRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const loadScript = () => {
      const script = document.createElement('script');
      script.src = 'https://checkout.razorpay.com/v1/checkout.js';
      script.async = true;
      document.body.append(script);
    };
    loadScript();
  }, []);
  useEffect(() => {
    // console.log('Check', paymentPending, appointmentID, paymentID);
    if (!paymentPending && !appointmentID && paymentID) {
      setStartTimer(true);
      // startCountDown(paymentID);
    }
  }, [paymentPending, paymentID, appointmentID]);
  useEffect(() => {
    if (!startTimer) return;
    // console.log('Starting count down', startTimer);
    startCountDown(paymentID);
  }, [startTimer]);

  useEffect(() => {
    if (startTimer) {
      countDownRef.current = setInterval(() => {
        setSeconds((prevSeconds) => {
          if (prevSeconds === 0) {
            setMinutes((prevMinutes) => {
              if (prevMinutes === 0) {
                clearInterval(countDownRef.current);
                clearInterval(pollingRef.current);
                redirectTo(paymentData);
                return 0;
              }
              return prevMinutes - 1;
            });
            return 59;
          }
          return prevSeconds - 1;
        });
      }, 1000);
    }

    return () => {
      clearInterval(countDownRef.current);
      clearInterval(pollingRef.current);
    };
  }, [startTimer]);

  // Open Razorpay Payment
  const openRazorpay = () => {
    const myHeaders = new Headers();
    myHeaders.append('db_ptr', paymentData.db_ptr);
    myHeaders.append('mode', 'booking');
    myHeaders.append('Content-Type', 'application/json');
    myHeaders.append('Authorization', `Bearer ${paymentData.authToken}`);

    const raw = JSON.stringify({
      paymentRefId: paymentData.order_id,
    });

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow',
    };

    fetch(
      'https://nura-payment-develop.onedesk.app/payment/initiate-order',
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => {
        result = JSON.parse(result);
        // console.log('Result of initiate payment ', result.data.id);
        if (result.success) {
          const amount = Number(result.amount);
          // Your Razorpay API Key
          const razorpayApiKey = process.env.REACT_APP_RAZORPAY_KEY;
          const options = {
            key: razorpayApiKey,
            amount: amount * 100, // Amount in paise
            currency: 'INR',
            order_id: result.data.id,
            description: 'Payment for NURA',
            handler: function (response) {
              const paymentID = response.razorpay_payment_id;
              setPaymentID(paymentID);
              setBeforePayment(false);
            },
            prefill: {
              name: 'Customer Name',
              email: 'customer@example.com',
              contact: 'customer_phone_number',
            },
            modal: {
              ondismiss: function () {
                const finalPaymentData = {
                  ...paymentData,
                  paymentID: null,
                  paymentSuccess: false,
                };
                setPaymentData(finalPaymentData);
                redirectTo(finalPaymentData);
              },
            },
          };

          const rzp = new Razorpay(options);
          rzp.open();
        }
      })
      .catch((error) => console.error(error));
  };
  const startCountDown = (pid) => {
    const maxAttempts = 200;
    let attempts = 0;
    pollingRef.current = setInterval(() => {
      attempts += 1;
      // console.log('Attempts', attempts);
      updatePaymentStatus(pid, attempts); //change this
      if (attempts > maxAttempts) {
        clearInterval(pollingRef.current);
        clearInterval(countDownRef.current);
        const finalPaymentData = {
          ...paymentData,
          paymentID: pid,
          paymentSuccess: false,
        };
        setPaymentData(finalPaymentData);
        redirectTo(finalPaymentData);
      }
    }, 3000);
  };
  const updatePaymentStatus = (paymentID, attempts) => {
    // console.log('Attempt inside', attempts);
    // console.log('payment ID', paymentID);

    const myHeaders = new Headers();
    myHeaders.append('db_ptr', paymentData.db_ptr);
    myHeaders.append('Authorization', `Bearer ${paymentData.authToken}`);

    const requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow',
    };

    fetch(
      `https://nura-api-india-release-20.onedesk.app:8413/dev/bookings/payment-status?payment_id=${paymentID}`,
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => {
        result = JSON.parse(result);
        // console.log('Payment status ', result);
        const finalPaymentData = {
          ...paymentData,
          paymentID: paymentID,
          paymentSuccess: result.success,
          paymentResult: result,
        };
        if (result.success) {
          setAppointmentID(result.data);
          setPaymentData(finalPaymentData);
          clearInterval(countDownRef.current);
          clearInterval(pollingRef.current);
          redirectTo(finalPaymentData);
        }
      })
      .catch((error) => console.error(error));
  };

  const redirectTo = (paymentData) => {
    setPaymentData(paymentData);
    const encrypted = CryptoJS.AES.encrypt(
      JSON.stringify(paymentData),
      process.env.REACT_APP_SECRET_KEY
    ).toString();

    window.name = encrypted;
    //window.location.href = 'http://localhost:3000/booking-status';

    window.location.href = 'https://nura-pwa.web.app/booking-status';
  };
  return (
    <div
      className={'vertical-padding-32 '}
      style={{
        background: 'linear-gradient(180deg, #FBF9EE 5.29%, #82B8EE 72.12%)',
      }}
    >
      {/* <div
        style={{
          background: 'rgba(19, 19, 19, 0.6)',
          backdropFilter: 'blur(2px)',
          height: '100vh',
          position: 'absolute',
          inset: '0',
          width: '100%',
          zIndex: '101',
        }}
      > */}
      {/* <div
          className="padding-32 col flex-center-align text-center-align "
          style={{
            width: '25%',
            margin: '20% auto',
            borderRadius: '8px',
            gap: '12px',
            background: '#fff',
            border: '1px solid  #E1E3E5;',
          }}
        >
          <div className="title-3">
            Are you sure you want to leave this page?
          </div>
          <div className="body-1 regular">
            Your payment is still processing. Leaving now could cancel your
            attempt and require you to start over.
          </div>
          <div className="row justify-center " style={{ gap: '12px' }}>
            <button className="secondary-btn-regular">Leave anyway</button>
            <button className="primary-btn-large">Stay on page</button>
          </div>
        </div> */}
      {/* <div
          className="padding-32 col "
          style={{
            width: '50%',
            margin: '20% auto',
            borderRadius: '8px',
            gap: '12px',
            background: '#fff',
            border: '1px solid  #E1E3E5;',
          }}
        >
          <div className="title-3">Need help with your payment?</div>
          <div className="body-1 regular">
            If you’re unsure about your payment status or need help completing
            your booking, fill out the form below and our team will get back to
            you shortly.
          </div>
          <div className="row space-between" style={{ gap: '24px' }}>
            <div className="col" style={{ flex: '0 0 40%' }}>
              <div className="body-3 text-grey-500">Name</div>
              <input
                type="text"
                name="username"
                id="username"
                className="body-1 regular"
              />
            </div>
            <div className="col" style={{ flex: '0 0 40%' }}>
              <div className="body-3 text-grey-500">Phone number</div>
              <input
                type="text"
                name="username"
                id="username"
                className="body-1 regular"
              />
            </div>
          </div> */}
      {/* <div>
            <input type="textarea" row={5} />
          </div>
          <div className="row justify-center " style={{ gap: '12px' }}>
            <button className="secondary-btn-regular">Cancel</button>
            <button className="primary-btn-large">Submit</button>
          </div>
        </div>
      </div> */}
      <div
        style={{
          width: '83%',
          position: 'relative',
          height: '90vh',
          margin: 'auto',
        }}
      >
        {' '}
        {paymentPending && (
          <div className="slotContainer margin-bottom-24">
            <div className="vertical-padding-32 ">
              <div className="row slotRowContainer">
                <div className="margin-right-24 text-coal-dark firstChild">
                  <div className="title-2 margin-bottom-12">
                    Choose how you’d like to pay
                  </div>
                  <div
                    className="bg-slate-100 border-radius-6 padding-16"
                    style={{
                      boxShadow:
                        ' 0px 1.444px 5.778px 0px rgba(80, 114, 169, 0.12)',
                    }}
                  >
                    <button
                      onClick={openRazorpay}
                      className="primary-btn-large enabled body-1 medium"
                    >
                      Pay with Razorpay
                    </button>
                  </div>
                </div>
              </div>
            </div>{' '}
          </div>
        )}
        {startTimer && (
          <div style={{ margin: 'auto', height: '100%' }}>
            <div
              className="col flex-center-align justify-center bg-white border-radius-12 padding-32"
              style={{ width: '27%', margin: 'auto', height: 'max-content' }}
            >
              <div>
                <img src={spinner} alt="waiting for appointment id" />
              </div>
              <div className="vertical-margin-32 text-coal-dark text-center-align">
                <div className="title-5 strong ">
                  {minutes > 5
                    ? 'Processing your payment...'
                    : 'Still processing your payment...'}
                </div>
                <div className="vertical-margin-4 body-1 regular">
                  {minutes > 5
                    ? 'This may take a moment. Please don’t refresh or close the window.'
                    : 'If you’ve been charged but haven’t received confirmation, don’t worry—we’ll update you shortly.'}
                </div>
                <div className="row flex-center-align justify-center">
                  <img
                    className="margin-right-4"
                    src={clock}
                    alt="It may take upto 10 minutes"
                  />

                  <div className="text-grey-500">{`${minutes}:${seconds < 10 ? '0' + seconds : seconds}`}</div>
                </div>
              </div>
              <div className="text-slate-700">Need Help? Contact Support</div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default IndiaPayment;
